// Zentrale Referenz-Konstanten für das Frontend.
// Quelle der Wahrheit (Backend): domain/constants.py — die Listen hier MÜSSEN
// damit übereinstimmen. Per GET /api/constants kann das Frontend die Werte
// zur Laufzeit überschreiben (fetchConstants), nutzt aber sonst diese Defaults.

import { apiFetch } from "./client";

export const ANREDEN: string[] = ["Herr", "Frau", "Divers", "Firma / Organisation"];
export const ANREDEN_KONUS: string[] = ["Herr", "Frau", "Divers", "Keine Angabe"];

export const GRUPPENARTEN: string[] = [
  "BdP BaWü (Stämme oder LV)",
  "rdp (alle außer BdP)",
  "Schule",
  "Diverse Jugendgruppen",
  "Familie",
  "Erwachsene",
  "Hochschule / Uni",
];

export const SAISONS: string[] = ["Sommer", "Winter"];
export const SAISON_DEFAULT = "Sommer";

export const WORKFLOW_SCHRITTE: { name: string; color: string }[] = [
  { name: "Angelegt", color: "#2196F3" },
  { name: "Bestätigt", color: "#FF9800" },
  { name: "Konus Link versandt", color: "#9C27B0" },
  { name: "Konus-Daten eingegeben", color: "#7E57C2" },
  { name: "Infos an Gruppe versandt", color: "#00BCD4" },
  { name: "Abgereist", color: "#607D8B" },
  { name: "Rechnung erstellt", color: "#FF5722" },
  { name: "Bezahlt", color: "#4CAF50" },
];

export const STORNO_STATUS = { name: "Storniert", color: "#F44336" };
export const INTERN_STATUS = { name: "Intern", color: "#607D8B" };

export const WORKFLOW_STATUS: string[] = [
  ...WORKFLOW_SCHRITTE.map((s) => s.name),
  STORNO_STATUS.name,
  INTERN_STATUS.name,
];

export type WorkflowStatus = string;

export const WORKFLOW_COLORS: Record<string, string> = Object.fromEntries([
  ...WORKFLOW_SCHRITTE.map((s) => [s.name, s.color]),
  [STORNO_STATUS.name, STORNO_STATUS.color],
  [INTERN_STATUS.name, INTERN_STATUS.color],
]);

type ConstantsPayload = {
  gruppenarten: string[];
  anreden: string[];
  anreden_konus: string[];
  saisons: string[];
  saison_default: string;
  workflow_schritte: { name: string; color: string }[];
  workflow_status: string[];
  workflow_colors: Record<string, string>;
  storno_status: { name: string; color: string };
  intern_status: { name: string; color: string };
};

export function fetchConstants(): Promise<ConstantsPayload> {
  return apiFetch<ConstantsPayload>("/api/constants");
}
